<div #ordenableTool class="ordenable-tool d-none">
  <button type="button">
    <span class="material-symbols-outlined"> swap_vert </span>
  </button>
</div>

<div class="container-table-pro" #container>
  <form [formGroup]="form">
    @if (configs?.hasItemsPerPageSelector || configs?.hasSearchBox) {
      <div class="actions-top">
        <div class="action-1">
          @if (configs?.hasItemsPerPageSelector) {
            <div class="form-group">
              <label>
                <select class="form-control" formControlName="itemsPerPage">
                  <option value="" disabled selected>{{ 'generic.selectAnOption' | cxTranslate }}</option>
                  <option *ngFor="let item of qtyOptions" [attr.aria-label]="item.label" value="{{ item.code }}">
                    {{ item.label }}
                  </option>
                </select>
              </label>
            </div>
          }

          <ng-content select="[top-action-1]"></ng-content>
        </div>

        <div class="action-2">
          @if (configs?.hasSearchBox) {
            <div class="form-group">
              <label>
                <input
                  class="form-control"
                  type="text"
                  name="search"
                  maxlength="255"
                  placeholder="{{ 'tablePro.inputSearchPlaceholder' | cxTranslate }}"
                  formControlName="search"
                />
              </label>
            </div>
          }
          <ng-content select="[top-action-2]"></ng-content>
        </div>
      </div>
    }

    <ng-content></ng-content>

    <div class="actions-bottom" [ngClass]="{ 'floatting-bottom': configs?.floattingBottom }">
      <div class="action-1">
        @if (pagination && (pagination?.totalPages || 0) > 1) {
          <ng-container *ngIf="getPaginationTotalLabel(pagination) | async as paginationTotalLabel">
            {{ paginationTotalLabel }}
          </ng-container>
        }
      </div>

      <div class="action-2">
        <cx-custom-pagination [pagination]="pagination" (viewPageEvent)="pageChange($event)" [pageRoute]="''"></cx-custom-pagination>
      </div>

      <div class="action-3"></div>
    </div>
  </form>
</div>
